import { render, staticRenderFns } from "./PathologyReportPanel.vue?vue&type=template&id=d903ced6"
import script from "./PathologyReportPanel.vue?vue&type=script&lang=js"
export * from "./PathologyReportPanel.vue?vue&type=script&lang=js"
import style0 from "./PathologyReportPanel.vue?vue&type=style&index=0&id=d903ced6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports